var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM23.412 11.574L15.748 23.288C15.746 23.29 15.742 23.292 15.742 23.294C15.702 23.354 15.68 23.422 15.63 23.478C15.56 23.554 15.47 23.594 15.39 23.652C15.37 23.666 15.35 23.682 15.328 23.696C15.204 23.774 15.076 23.826 14.936 23.86C14.89 23.872 14.848 23.884 14.8 23.892C14.6886 23.9073 14.5757 23.9087 14.464 23.896C14.3851 23.891 14.3068 23.879 14.23 23.86C14.1508 23.8361 14.0738 23.8053 14 23.768C13.936 23.738 13.868 23.73 13.808 23.692C13.764 23.664 13.74 23.62 13.702 23.586C13.686 23.572 13.666 23.568 13.65 23.554L9.188 19.428C8.92352 19.174 8.76922 18.8265 8.75828 18.46C8.74733 18.0934 8.88061 17.7373 9.12946 17.468C9.37832 17.1987 9.72289 17.0378 10.0891 17.0198C10.4553 17.0019 10.814 17.1283 11.088 17.372L14.318 20.36L21.068 10.042C21.2712 9.73117 21.5895 9.51377 21.9529 9.43763C22.3164 9.36149 22.6952 9.43284 23.006 9.636C23.3168 9.83916 23.5342 10.1575 23.6104 10.5209C23.6865 10.8844 23.6152 11.2632 23.412 11.574Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/passwordReset.b3a4e3fcbe113f5ac40e67a019fa2e3d.svg";
export { ForwardRef as ReactComponent };